import JobCreatorSection from "@/components/sections/Section01/JobCreatorSection";
import TitleSection from "@/components/sections/Section02/TitleSection";
import ToolsAndAppsSection from "@/components/sections/Section03/ToolsAndAppsSection";
import TitleOnLeftAndImageOnRightWithButton from "@/components/sections/Section04/TitleOnLeftAndImageOnRightWithButton";
import FeaturesSection from "@/components/sections/Section05/FeaturesSection";
import FeaturesSectionWithATitle from "@/components/sections/Section06/FeaturesSectionWithATitle";
import UseCasesSection from "@/components/sections/Section07/UseCasesSection";
import IntegrationsSection from "@/components/sections/Section08/IntegrationsSection";
import MentionsSection from "@/components/sections/Section09/MentionsSection";
import HighlightsSection from "@/components/sections/Section10/HighlightsSection";
import PressSection from "@/components/sections/Section11/PressSection";
import SocialSection from "@/components/sections/Section12/SocialSection";
import TestimonialsSection from "@/components/sections/Section13/TestimonialsSection";
import TrustSection from "@/components/sections/Section14/TrustSection";
import HowItWorksSection from "@/components/sections/Section15/HowItWorksSection";
import FindPlanSection from "@/components/sections/Section16/FindPlanSection";
import JobHistorySection from "@/components/sections/Section17/JobHistorySection";
import EmailAlertSection from "@/components/sections/Section18/EmailAlertSection";
import HeroSection from "@/components/sections/Section19/HeroSection";
import PostsSection from "@/components/sections/Section20/PostsSection";
import FaqSection from "@/components/sections/Section21/FaqSection";
import GetAccessSection from "@/components/sections/Section22/GetAccessSection";
import RelatedPagesSection from "@/components/sections/Section24/Section24";
import CarouselSection from "@/components/sections/Section26/CarouselSection";
import ButtonEditorSection from "@/components/sections/Section27/Section27";
import HeaderAndButton from "@/components/sections/Section28/HeaderAndButton";
import TermsOfUseSection from "@/components/sections/Section29/Section29";

export const CmsServiceComponent = {
  "sections.section01": JobCreatorSection,
  "sections.section02": TitleSection,
  "sections.section03": ToolsAndAppsSection,
  "sections.section04": TitleOnLeftAndImageOnRightWithButton,
  "sections.section05": FeaturesSection,
  "sections.section06": FeaturesSectionWithATitle,
  "sections.section07": UseCasesSection,
  "sections.section08": IntegrationsSection,
  "sections.section09": MentionsSection,
  "sections.section10": HighlightsSection,
  "sections.section11": PressSection,
  "sections.section12": SocialSection,
  "sections.section13": TestimonialsSection,
  "sections.section14": TrustSection,
  "sections.section15": HowItWorksSection,
  "sections.section16": FindPlanSection,
  "sections.section17": JobHistorySection,
  "sections.section18": EmailAlertSection,
  "sections.section19": HeroSection,
  "sections.section20": PostsSection,
  "sections.section21": FaqSection,
  "sections.section22": GetAccessSection,
  "sections.section24": RelatedPagesSection,
  "sections.section26": CarouselSection,
  "sections.section27": ButtonEditorSection,
  "sections.section28": HeaderAndButton,
  "sections.section29": TermsOfUseSection,
} as const;

export const toFooterColumns = (footer?: any) => {
  // Cms nesting limits prevents modelling columns as a list.
  return [
    {
      title: footer?.Column02Title,
      list: footer?.Column02List,
    },
    {
      title: footer?.Column03Title,
      list: footer?.Column03List,
    },
    {
      title: footer?.Column04Title,
      list: footer?.Column04List,
    },
    {
      title: footer?.Column05Title,
      list: footer?.Column05List,
    },
  ];
};

export const toSelectOptions = (select?: any) => {
  const optionLabels = select?.OptionLabels?.split(", ") ?? [];
  const optionValues = select?.OptionValues?.split(", ") ?? [];

  return optionLabels.map((label: string, index: number) => {
    return {
      label,
      value: optionValues[index],
    };
  });
};
